import { questionInputLayoutTypes } from '../../constants/question-input-layout-types'

let _maxQuestionCodeLength = 20;

export function setMaxQuestionCodeLength(maxLength) {
	_maxQuestionCodeLength = maxLength;
}

export function getMaxQuestionCodeLength() {
	return _maxQuestionCodeLength;
}

export function isValidQuestionCode(code) {
	const pattern = new RegExp(`^[a-zA-Z][a-zA-Z0-9_-]{2,${_maxQuestionCodeLength - 1}}$`);
	return code && pattern.test(code);
}

export function getQuestionCodeValidationError(fieldName = 'Question code') {
	return `${fieldName} can contain only letters, numbers, underscore and hyphen, must start with a letter, and be between 3 and ${_maxQuestionCodeLength} characters long.`;
}

function ValidateQuestion(selectedQuestion, defaultLanguageCode) {
	var validationErrors = [];
	const gridSubType = getGridSubType(selectedQuestion);
	const questionTypeToValidate = selectedQuestion.questionType === "GGROUP" ? gridSubType : selectedQuestion.questionType;
	validateQuestionCode(validationErrors, selectedQuestion.code);
	var defaultTexts = selectedQuestion.texts?.find(t=>t.languageCode === defaultLanguageCode);
	if (!defaultTexts || defaultTexts.text === '') {
		addErrorMessage(validationErrors, 'text', `The default language '${defaultLanguageCode}' question text is empty`);
	}
	
	if (questionTypeToValidate !== "OPEN" && questionTypeToValidate !== "NUMERIC" && questionTypeToValidate !== "INTRO") {
		if (!selectedQuestion.options || selectedQuestion.options.length === 0) {
			addErrorMessage(validationErrors, 'options', 'questions other than Open, Number Input or Intro Question must have options');                        
		}

		validadeOptions(validationErrors, selectedQuestion.options, defaultLanguageCode);
	}

	if (questionTypeToValidate === "NUMERIC") {		
		if (selectedQuestion.numericMin === '' || selectedQuestion.numericMin == null) {
			addErrorMessage(validationErrors, 'numericMin', 'Number Input questions must have a min. value');                        
		}

		if (selectedQuestion.numericMax === '' || selectedQuestion.numericMax == null) {
			addErrorMessage(validationErrors, 'numericMax', 'Number Input questions must have a max. value');                        
		}
		validadeOptions(validationErrors, selectedQuestion.options, defaultLanguageCode);
		
		if (selectedQuestion.layoutType === questionInputLayoutTypes.CircularSlider) {
			if (parseInt(selectedQuestion.numericMax) - parseInt(selectedQuestion.numericMin) > 100) {
				addErrorMessage(validationErrors, 'numericMax', 'Circular slider must have a maximum of 100 steps.');  
			}
		}
	}

	if (selectedQuestion.questionType === "GGROUP") {
		if (!selectedQuestion.groupStatements || selectedQuestion.groupStatements.length === 0) {
			addErrorMessage(validationErrors, 'gridQuestion_required', 'Grid questions must have at least one statement');
		}

		if (selectedQuestion.groupStatements) {
			for (let index = 0; index < selectedQuestion.groupStatements.length; index++) {
				const gridQuestion = selectedQuestion.groupStatements[index];

				if (!gridQuestion.questionType || gridQuestion.questionType === 'GGROUP') {
					addErrorMessage(validationErrors, `gridQuestion_type_${index}`, 'Grid statement subtype is invalid');
				} else if (gridSubType && gridQuestion.questionType !== gridSubType) {
					addErrorMessage(validationErrors, `gridQuestion_type_${index}`, 'All grid statements must have the same subtype');
				}

				if (!gridQuestion.code || gridQuestion.code === '') {                    
					addErrorMessage(validationErrors, `gridQuestion_code_${index}`, 'question code is empty');					
				}					
				var defaultGridTexts = gridQuestion.texts?.find(t=>t.languageCode === defaultLanguageCode);					
				if (!defaultGridTexts || defaultGridTexts.text == null || defaultGridTexts.text === '') {
					addErrorMessage(validationErrors, `gridQuestion_text_${index}`, `The default language '${defaultLanguageCode}' question text is empty`);
				}
			}			
		}
	}
	return validationErrors;
}

function getGridSubType(selectedQuestion) {
	if (!selectedQuestion || selectedQuestion.questionType !== 'GGROUP') {
		return null;
	}

	if (!selectedQuestion.groupStatements || selectedQuestion.groupStatements.length === 0) {
		return null;
	}

	const typedGridQuestion = selectedQuestion.groupStatements.find(q => q.questionType && q.questionType !== 'GGROUP');
	return typedGridQuestion ? typedGridQuestion.questionType : null;
}

function validateQuestionCode(validationErrors, questionCode) {	
	if (!questionCode || questionCode === '') {                    
		addErrorMessage(validationErrors, 'code', 'question code is empty');
	} else if (!isValidQuestionCode(questionCode)) {                    
		addErrorMessage(validationErrors, 'code', getQuestionCodeValidationError());
	}
}

function validadeOptions(validationErrors, options, defaultLanguageCode) {
	options.forEach((questionOption) => {
		var defaultTexts = questionOption.texts?.find(t=>t.languageCode === defaultLanguageCode);
		if (!defaultTexts || defaultTexts.text === '') {
			addErrorMessage(validationErrors, 'text', `The default language '${defaultLanguageCode}'question text is empty`);
			addErrorMessage(validationErrors, `option_${questionOption.value}`, `The default language '${defaultLanguageCode}' Option must have a text`);
		}
	});
}

function addErrorMessage(validationErrors, field, message) {      
	validationErrors.push({ field: field, errorMessage: message});      
}

export default ValidateQuestion;

